<app-steps [step]='3'></app-steps>

<div class="row">
    <div class="col-sm-5">
        <div class="card floating shadow-lg">
            <ul class="list-group list-group-flush">
                <li class="list-group-item">
                    <div class="row header">
                        <div class="col-7">
                            <i class="fas fa-shopping-cart"></i>&nbsp;Cart
                        </div>
                        <div class="col-5 text-right">
                            Price
                        </div>
                    </div>
                </li>
                <li class="list-group-item" *ngFor="let giftVoucher of app.basketItems; let i= index">
                    <div class="row">
                        <div class="col-8">
                            <span class="">
                                {{giftVoucher.description}}
                                <a (click)="giftVoucher.selected=!giftVoucher.selected" class="blue d-none">
                                    <i class="fas fa-info-circle"></i>
                                </a>
                            </span>
                        </div>
                        <div class="col-4 text-right">
                            <span *ngIf="app.config!=null" [innerHTML]="app.config.currencySymbol"></span>{{giftVoucher.fee | number: '1.2'}}
                            &nbsp;<a class="float-right red" (click)="app.delete(i);computeOrder();">
                                <i class="fas fa-times"></i>
                            </a>
                        </div>
                    </div>                    
                    <div class="row" *ngIf="!giftVoucher.selected">
                        <div class="col-12">
                            <span class="border-gray" value="">
                                <small *ngIf="giftVoucher.invoiceDetailType==4">
                                    <b>Gift Voucher Details</b><br>
                                    <b>Beneficiary:</b> {{giftVoucher.giftVoucherReceiverCollectorName}}<br>
                                    <b>Message:</b> {{giftVoucher.giftVoucherMessage}}
                                </small>
                                <small *ngIf="giftVoucher.invoiceDetailType==1">
                                    <b>Appointment Details</b><br>
                                    <b>Date & Time:</b> {{giftVoucher.startTime | date: 'MMM d, y - h:mm a'}}<br>
                                    <b>Staff:</b> {{giftVoucher.staffName}}<br>
                                    <b>Price:</b>&nbsp;<span [innerHTML]="app.config.currencySymbol"></span>{{giftVoucher.originalFee | number: '1.2'}}
                                    <span *ngIf="app.config!=null && giftVoucher.depositPercentage>0">
                                        <br>
                                        <b>Deposit:</b>&nbsp;<span [innerHTML]="app.config.currencySymbol"></span>{{giftVoucher.depositAmount | number: '1.2'}}
                                    </span>
                                </small>
                            </span>
                        </div>
                    </div>
                </li>
                <li class="list-group-item">
                    <div class="row">
                        <div class="col-7">
                            <span class="form-control-plaintext font-weight-bold">Total</span>
                        </div>
                        <div class="col-5">
                            <span class="form-control-plaintext text-right font-weight-bold">
                                <span *ngIf="app.config!=null" [innerHTML]="app.config.currencySymbol"></span>{{app.totalAmount
                                |
                                number: '1.2'}}
                            </span>
                        </div>
                    </div>
                </li>
            </ul>
            <hr>
            <div class="card-footer">
                <div class="row">
                    <div class="col-12">
                        <a class="" (click)="gotoHome()">Book another appointment</a>
                        <br>
                        <a class="" (click)="gotoVoucher()">Add a gift voucher</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-7">
        <div class="card bg-transparent">
                        
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <h3 class="card-title main-title">Checkout</h3>
                    </div>
                </div>
                <hr>
                <div class="card-title">
                    <b>Contact Details</b>
                </div>
                <div class="row" *ngIf="app!=null && app.customer!=null">
                    <div class="col-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Your name</mat-label>
                            <input matInput readonly value="{{app.customer.firstName}}&nbsp;{{app.customer.lastName}}"
                                type="text">
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-7">
                        <mat-form-field appearance="outline">
                            <mat-label>Email</mat-label>
                            <input matInput readonly value="{{app.customer.email}}" type="text">
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-5">
                        <mat-form-field appearance="outline">
                            <mat-label>Phone</mat-label>
                            <input matInput readonly value="{{app.customer.mobilePhoneNumber}}" type="text">
                        </mat-form-field>
                    </div>
                </div>
                <div class="card-title" *ngIf="app.hasBookingItem">
                    <mat-checkbox [(ngModel)]="acceptTerms">
                        <b>I accept the Terms of use.</b>
                    </mat-checkbox>
                </div>
                <mat-form-field appearance="outline" *ngIf="app.hasBookingItem">
                    <mat-label>Terms of use</mat-label>
                    <textarea style="height: 200px;" matInput readonly type="text">We understand that unexpected issues may arise and you may need to reschedule or cancel an appointment. If that happens we respectfully ask for 24 hours notice. Our Practitioners want to be available for all patient’s needs. When a patient does not show up for a scheduled appointment another patient loses an opportunity to be seen.&#13;&#13;All required deposits and payments are refundable with a minimum of 24 hours notice.&#13;&#13;Failure to provide 24 hours notice for rescheduling or cancellation of an appointment and/or failure to attend an appointment will incur a $50 charge. We thank you for understanding.
                    </textarea>
                </mat-form-field>
                <div *ngIf="!app.hasGiftVoucherItem">
                    <div class="card-text">
                        <strong>If you will be using a Gift Voucher please click below</strong>
                    </div>
                    <br>
                    <a class="btn btn-blue full-width" (click)="redirectToGiftVoucherRedemption()">
                        Gift Voucher No.
                    </a>
                    <br>
                    <br>
                </div>
                <div *ngIf="app!=null && app.customer!=null && 
                    !app.customer.isNewCustomer && 
                    !app.customer.is2YearLastTransaction && 
                    !app.isPassSeven && 
                    app.hasBookingItem &&
                    !app.hasGiftVoucherItem">
                    <div class="card-text">
                        <strong>or click pay at time of your Appointment to Book</strong>
                    </div>
                    <br>
                    <button class="btn btn-blue full-width" (click)="confirmAppointment()">
                        Pay at the Appointment
                    </button>
                    <br>
                    <br>
                </div>
                <div *ngIf="app!=null && app.customer!=null && !app.customer.isNewCustomer && !app.customer.is2YearLastTransaction">
                    <div *ngIf="showPayPal">
                        <div class="card-text">
                            <strong>Click the PayPal Button to pay for the items in the Cart, using PayPal or a Credit Card.</strong>
                        </div>
                        <br>
                        <a id="paypal-button-container" class="full-width"></a>
                    </div>
                    <br>
                </div>
                <div *ngIf="app.customer!=null && (app.customer.isNewCustomer || app.customer.is2YearLastTransaction) && showPayPal">
                    <div class="card-text">
                        <strong>Click the PayPal Button to pay for the items in the Cart, using PayPal or a Credit Card.</strong>
                    </div>
                    <br>
                    <a id="paypal-button-container" class="full-width"></a>
                </div>
            </div>
        </div>
    </div>
</div>